import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

// namespace SlotGames {

    export class IcyFresh_Responsive extends SlotGameType1_Responsive {

        
        protected override helpFactory: IHelpFactory = new IcyFreshHelpFactory();
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData , gameName : string = "IcyFresh") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // protected PrepareFonts(resourceManager: ResourceManager): void {

        //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

        // }

           //SEND COLOR FOR RSA 
           protected override color: RewardColor =
           {
               color: "#0A7CBF",
               coloroutherStroke: "black",
               colorinnerStroke: "#031333",
           }

    }

    
    //Help Colorized
    class IcyFreshHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new IcyFreshHelp(params);
        }
    }

    class IcyFreshHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
// }